import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import confirm from "../../../shared/modal/confirm";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../shared/loader";
import {
  clearRedirect,
  deleteTaskStatus,
  fetchTaskStatus,
  updateTaskStatus
} from "./ducks/actions";
import Form from "./form";
import Onboarding from "../../../shared/onboarding/onboarding";

function EditProp(props) {
  const filmId = props.filmId || props.match.params.filmId;
  const taskStatusId = props.taskStatusId || props.match.params.taskStatusId;

  const {
    fetchTaskStatus,
    updateTaskStatus,
    deleteTaskStatus,
    clearRedirect,
    loading,
    saving,
    taskStatus,
    errors,
    redirect,
    onboardingSteps
  } = props;

  const invalidIds = ["add", "overview", "order"];

  useEffect(() => {
    if (invalidIds.indexOf(taskStatusId) === -1) {
      fetchTaskStatus(filmId, taskStatusId);
    }
  }, [filmId, taskStatusId]);

  if (redirect) {
    if (redirect.to === "list") {
      clearRedirect();
      const url = `/films/${filmId}/task-statuses/`;
      return <Redirect to={url} />;
    }
  }

  if (invalidIds.indexOf(taskStatusId) > -1) {
    return null;
  }

  function renderLoading() {
    return <Loader />;
  }

  function renderTaskStatus(taskStatus) {
    return (
      <ScrollIntoView
        className="blade-content widest"
        path="/films/:filmId/task-statuses/:taskStatusId/edit"
        loading={loading}>
        <Form
          errors={errors}
          mode="edit"
          filmId={filmId}
          initialValues={taskStatus}
          loading={loading}
          onSubmit={onUpdateTaskStatus}
          handleDelete={onDeleteTasStatus}
          reduxFormValues={props.reduxFormValues}
        />
        <Onboarding onboardingSteps={onboardingSteps} section="Task Status" />
      </ScrollIntoView>
    );
  }

  function onUpdateTaskStatus(taskStatus) {
    updateTaskStatus(filmId, taskStatusId, taskStatus);
  }

  function onDeleteTasStatus(taskStatus) {
    confirm(() => deleteTaskStatus(filmId, taskStatusId), taskStatus?.name);
  }

  return !loading && !saving ? renderTaskStatus(taskStatus) : renderLoading();
}

function mapStateToProps(state) {
  const { taskStatusesState } = state;
  const { rootState } = taskStatusesState;
  return {
    onboardingSteps: rootState.onboardingSteps,
    taskStatus: rootState.taskStatus,
    errors: rootState.errors,
    loading: rootState.loading,
    redirect: rootState.redirect,
    saving: rootState.saving,
  };
}

export default connect(mapStateToProps, {
  fetchTaskStatus,
  updateTaskStatus,
  deleteTaskStatus,
  clearRedirect
})(EditProp);
